define('answerTypes', [], function () {
	return [
        {
            type: 'text', name: 'Text', icon: 'fa fa-file-text-o'
        },
        {
            type: 'sound', name: 'Sound', icon: 'fa fa-music'
        },
        {
            type: 'image', name: 'Image', icon: 'fa fa-picture-o'
        },
        {
            type: 'color', name: 'Color', icon: 'fa fa-paint-brush'
        },
        {
            type: 'video', name: 'Video', icon: 'fa fa-video-camera'
        }
    ];
});